/** @format */

/**
 * Catalogo unico de tipos de orden de trabajo de lusazu.
 * Antes esta informacion estaba repartida entre el template y formatoTipo(),
 * y los tipos sin ruta (microorganismos) mandaban al usuario a un 404.
 */
export const TIPOS = {
	lusazu: {
		base: 'lusazu',
		etiqueta: 'Servicios',
		etiquetaEmergencia: 'Servicio emergencia',
		color: '#0057c6',
		icono: 'mdi-spray-bottle',
		esCertificado: false,
		tieneVista: true,
		tieneCertificacion: true,
	},
	'lusazu-certificate': {
		base: 'lusazu',
		etiqueta: 'Servicios',
		etiquetaEmergencia: 'Servicio emergencia',
		color: '#0057c6',
		icono: 'mdi-spray-bottle',
		esCertificado: true,
		tieneVista: true,
		tieneCertificacion: true,
	},
	roedores: {
		base: 'roedores',
		etiqueta: 'Roedores',
		etiquetaEmergencia: 'Roedores emergencia',
		color: '#6fb301',
		icono: 'mdi-rodent',
		esCertificado: false,
		tieneVista: true,
		tieneCertificacion: true,
	},
	'roedores-certificate': {
		base: 'roedores',
		etiqueta: 'Roedores',
		etiquetaEmergencia: 'Roedores emergencia',
		color: '#6fb301',
		icono: 'mdi-rodent',
		esCertificado: true,
		tieneVista: true,
		tieneCertificacion: true,
	},
	'pre-roedores': {
		base: 'pre-roedores',
		etiqueta: 'Pre-Roedores',
		etiquetaEmergencia: 'Roedores emergencia',
		color: '#f2a20c',
		icono: 'mdi-clipboard-text-outline',
		esCertificado: false,
		tieneVista: true,
		tieneCertificacion: true,
	},
	'microorganismos-certificate': {
		base: 'microorganismos',
		etiqueta: 'Microorganismos',
		etiquetaEmergencia: 'Microorganismos emergencia',
		color: '#7d4aff',
		icono: 'mdi-biohazard',
		esCertificado: true,
		// no existe ruta para este tipo: los botones se muestran deshabilitados
		tieneVista: false,
		tieneCertificacion: false,
	},
};

const TIPO_DESCONOCIDO = {
	base: 'otro',
	etiqueta: 'Otro',
	etiquetaEmergencia: 'Otro',
	color: '#8a8a8a',
	icono: 'mdi-file-document-outline',
	esCertificado: false,
	tieneVista: false,
	tieneCertificacion: false,
};

export const infoTipo = tipo => TIPOS[tipo] || TIPO_DESCONOCIDO;

/** Opciones para el filtro de tipo (una por familia, no por variante) */
export const TIPOS_BASE = [
	{ valor: 'lusazu', texto: 'Servicios', color: TIPOS.lusazu.color },
	{ valor: 'roedores', texto: 'Roedores', color: TIPOS.roedores.color },
	{ valor: 'pre-roedores', texto: 'Pre-Roedores', color: TIPOS['pre-roedores'].color },
	{
		valor: 'microorganismos',
		texto: 'Microorganismos',
		color: TIPOS['microorganismos-certificate'].color,
	},
];

/** Etiqueta visible del tipo. `emergencia` viene de data[4] de la OT. */
export const formatoTipo = (tipo, emergencia) => {
	const info = infoTipo(tipo);
	return emergencia ? info.etiquetaEmergencia : info.etiqueta;
};

/**
 * Los enlaces se arman con la posicion de la OT dentro del array (indice), no
 * con workOrder.index: al certificar, ese campo quedo desalineado.
 */
export const rutaVerOT = (tipo, lodId, indice) => {
	const destino = tipo === 'pre-roedores' ? 'roedores' : tipo;
	return `#/${destino}/${lodId}/work-order/${indice}`;
};

export const rutaCertificar = (tipo, lodId, indice) => {
	const info = infoTipo(tipo);
	let destino = info.esCertificado ? tipo.split('-certificate')[0] : tipo;
	if (destino === 'pre-roedores') destino = 'roedores';
	return `#/${destino}/certificate/${lodId}/work-order/${indice}`;
};

export const rutaEditar = (tipo, lodId, indice) =>
	`${rutaCertificar(tipo, lodId, indice)}/?edicion=true`;
